import React, { useState } from 'react';
import { ExternalLink, Globe, Layers, ChevronDown } from 'lucide-react';
import './Portfolio.css';

const projects = [
    // Rad 1
    {
        title: "Sorento Pizzeria",
        url: "https://sorentopizza.se",
        displayUrl: "sorentopizza.se",
        status: "Live",
        type: "Restaurang",
        package: "Start",
        desc: "Meny, öppettider och hitta hit-karta — allt en gäst behöver för att välja Sorento.",
        image: "/images/portfolio/sorentopizza.webp"
    },
    {
        title: "Upptak",
        url: "https://utak.se",
        displayUrl: "utak.se",
        status: "Live",
        type: "Bygg / Energi",
        package: "Standard",
        desc: "Takläggning och solenergi presenterat så att kunden förstår tjänsten och enkelt kan begära offert.",
        image: "/images/portfolio/utak.webp"
    },
    {
        title: "Falu Ekonomi & Revision",
        url: "https://falurevision.se",
        displayUrl: "falurevision.se",
        status: "Live",
        type: "Företag",
        package: "Start",
        desc: "Tjänster och kontaktvägar för en lokal revisionsbyrå — byggd för tydlighet och förtroende.",
        image: "/images/portfolio/falurevision.webp"
    },
    // Rad 2
    {
        title: "FrogFMX",
        url: "https://frogfmx.com",
        displayUrl: "frogfmx.com",
        status: "Live",
        type: "Event / Sport",
        package: "Start",
        desc: "Eventsida för freestyle motocross med 3D-element och koppling till sociala medier.",
        image: "/images/portfolio/frogfmx.webp"
    },
    {
        title: "Slussbruden",
        url: "https://slussbruden.se",
        displayUrl: "slussbruden.se",
        status: "Live",
        type: "Turism / Event",
        package: "Standard",
        desc: "Kryssningar, bokning och allt om båten för M/S Slussbruden på sjön Runn — byggd för att fylla turerna.",
        image: "/images/portfolio/slussbruden.webp"
    },
    {
        title: "Svenska Produkter",
        url: "https://svenskaprodukter.se",
        displayUrl: "svenskaprodukter.se",
        status: "Live",
        type: "E-handel",
        package: "Pro",
        desc: "Komplett webbutik med produktkatalog, varukorg och betalningslösning.",
        image: "/images/portfolio/svenskaprodukter.webp"
    },
    // Rad 3 (drawer)
    {
        title: "Slätta Pizzeria",
        url: "https://slättapizzeria.se",
        displayUrl: "slättapizzeria.se",
        status: "Live",
        type: "Restaurang",
        package: "Start",
        desc: "Meny, öppettider och interaktiv karta så att gästerna hittar rätt direkt.",
        image: "/images/portfolio/slattapizza.webp"
    },
    {
        title: "Falukyrkan",
        url: "https://falukyrkan.se",
        displayUrl: "falukyrkan.se",
        status: "Live",
        type: "Organisation",
        package: "Standard",
        desc: "Gudstjänsttider, evenemang och kontakt — en samlingsplats för församlingen i Falun.",
        image: "/images/portfolio/falukyrkan.webp"
    },
    {
        title: "Tolka Live",
        url: "https://tolkalive.se",
        displayUrl: "tolkalive.se",
        status: "Live",
        type: "SaaS / App",
        package: "Pro",
        desc: "Webbapp som översätter talare i realtid — undertexter på skärmen och AI-röst i hörlurar på 75+ språk, direkt i webbläsaren.",
        image: "/images/portfolio/tolkalive.webp"
    },
    {
        title: "The Habit Quest",
        url: "https://thehabitquest.com",
        displayUrl: "thehabitquest.com",
        status: "Live",
        type: "SaaS / App",
        package: "Pro",
        desc: "Modern träningsapp med inloggning, databas och sociala funktioner.",
        image: "/images/portfolio/habitquest.webp"
    },
    // Prototyper — generiska demosidor, inte namngivna kunduppdrag
    {
        title: "Barber & Co",
        url: "https://ivansbarbershop.pages.dev/",
        displayUrl: "ivansbarbershop.pages.dev",
        status: "Prototyp",
        type: "Frisör",
        package: "Start",
        desc: "Tjänster, galleri och prislista för en barbershop — med bokningsförfrågan direkt på sidan.",
        image: "/images/portfolio/barberco.webp"
    },
    {
        title: "HLR-Akademin",
        url: "https://hlridalarna.pages.dev/",
        displayUrl: "hlridalarna.pages.dev",
        status: "Prototyp",
        type: "Utbildning",
        package: "Start",
        desc: "Kurser, upplägg och bokningsförfrågan för ett utbildningsföretag inom HLR och första hjälpen.",
        image: "/images/portfolio/hlrakademin.webp"
    },
    {
        title: "Nori Sushi",
        url: "https://fourbrother.pages.dev/",
        displayUrl: "fourbrother.pages.dev",
        status: "Prototyp",
        type: "Restaurang",
        package: "Standard",
        desc: "Meny, flera restauranger och beställning via Foodora för en sushirestaurang.",
        image: "/images/portfolio/norisushi.webp"
    },
    {
        title: "Liberty Pizza",
        url: "https://americantakeaway.pages.dev/",
        displayUrl: "americantakeaway.pages.dev",
        status: "Prototyp",
        type: "Restaurang",
        // Egen beställning med varukorg — prissätts efter funktion, inte paket
        priceFrom: "15 000",
        desc: "Meny, bygg din egen pizza och onlinebeställning med varukorg för en pizzeria.",
        image: "/images/portfolio/libertypizza.webp"
    }
];

const packagePrices = {
    Start: "5 000",
    Standard: "10 000",
    Pro: "30 000"
};

const ProjectCard = ({ project }) => (
    <a href={project.url} target="_blank" rel="noopener noreferrer" className="project-card">
        <div className="project-preview">
            <div className="browser-mockup">
                <div className="browser-header">
                    <div className="browser-dot red"></div>
                    <div className="browser-dot yellow"></div>
                    <div className="browser-dot green"></div>
                </div>
                <div className="browser-content" style={{ padding: 0 }}>
                    <img
                        src={project.image}
                        alt={project.title}
                        loading="lazy"
                        decoding="async"
                        width="1280"
                        height="800"
                        style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                    />
                </div>
            </div>
        </div>
        <div className="project-info">
            <div className="project-tags">
                <span className={`tag ${project.status === 'Live' ? 'live' : 'prototype'}`}>
                    {project.status === 'Live' ? <Globe size={12} style={{ marginRight: '4px', display: 'inline' }} /> : <Layers size={12} style={{ marginRight: '4px', display: 'inline' }} />}
                    {project.status}
                </span>
                <span className="tag type">
                    {project.type}
                </span>
                <span className="tag package">
                    {project.priceFrom
                        ? `Från ${project.priceFrom} kr`
                        : packagePrices[project.package]
                            ? `${project.package} · från ${packagePrices[project.package]} kr`
                            : project.package}
                </span>
            </div>
            <h3 className="project-title">{project.title}</h3>
            <p className="project-desc">{project.desc}</p>
            <span className="visit-link">
                Besök sida <ExternalLink size={16} />
            </span>
        </div>
    </a>
);

export default function Portfolio() {
    const [showMore, setShowMore] = useState(false);

    const liveProjects = projects.filter(p => p.status === 'Live');
    const prototypeProjects = projects.filter(p => p.status === 'Prototyp');
    const visibleProjects = liveProjects.slice(0, 6);
    const hiddenProjects = liveProjects.slice(6);

    return (
        <section className="portfolio" id="portfolio">
            <div className="container">
                <div className="section-header">
                    <span className="section-eyebrow">Portfolio</span>
                    <h2 className="section-title">Utvalda projekt</h2>
                    <p>Här är ett urval av hemsidor och prototyper vi har skapat. Vi anpassar varje projekt unikt efter kundens behov.</p>
                </div>

                <div className={`portfolio-grid portfolio-grid-main ${showMore ? 'expanded' : ''}`}>
                    {visibleProjects.map((project, index) => (
                        <ProjectCard key={index} project={project} />
                    ))}
                </div>

                {hiddenProjects.length > 0 && (
                    <>
                        <div className={`portfolio-drawer ${showMore ? 'open' : ''}`}>
                            <div className="portfolio-drawer-inner">
                                <div className="portfolio-grid">
                                    {hiddenProjects.map((project, index) => (
                                        <ProjectCard key={index} project={project} />
                                    ))}
                                </div>
                            </div>
                        </div>

                        <button
                            className="show-more-btn"
                            onClick={() => setShowMore(!showMore)}
                        >
                            <span>{showMore ? 'Visa färre' : 'Visa fler projekt'}</span>
                            <ChevronDown
                                size={20}
                                className={`show-more-icon ${showMore ? 'rotated' : ''}`}
                            />
                        </button>
                    </>
                )}

                {prototypeProjects.length > 0 && (
                    <div className="portfolio-prototypes">
                        <h3 className="portfolio-prototypes-title">Så här ser en gratis prototyp ut</h3>
                        <p className="portfolio-prototypes-lead">Så här långt kommer du innan du betalar något.</p>
                        <div className="portfolio-grid portfolio-grid-prototypes">
                            {prototypeProjects.map((project, index) => (
                                <ProjectCard key={index} project={project} />
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </section>
    );
}
